jQuery('.custom_button').click(function(){
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if (jQuery(this).hasClass("active")) {
   jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
    jQuery(this).removeClass('active');
video.trigger('pause');
} else {
video.trigger('play');
  jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
    jQuery(this).addClass('active');
}
});


jQuery('.video_wrapper_custom.video-active').click(function(){
    var video = jQuery(this).find('video');
var videoElement = video.get(0);
if (videoElement.paused) {
   jQuery(this).removeClass('video-active');
    jQuery(this).find('.custom_button').removeClass('active');
video.trigger('pause');
}  else {
}

});

jQuery(document).on('click','.review_add_to_cart',function(){ 
var link = jQuery(this).attr('href');
location.href=link;
});

jQuery(document).on('click','.add_to_cart_ajax:not(.build_set_redirect)',function(){ 
var this_element = jQuery(this);
jQuery(this).addClass('loading');
var ID = jQuery(this).attr("variant_id"); 
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: ID
},
  dataType: 'json', 
 success: function (data) { 
jQuery("cart-drawer").load(location.href + " #CartDrawer");
setTimeout(function() {
jQuery("cart-drawer").removeClass('is-empty').addClass('active');
jQuery("body ").addClass('overflow-hidden');
}, 1000);
this_element.removeClass('loading');
 } 
 });
}); 

jQuery('.collection_tab_trigger').click(function(){
var current_tab = jQuery(this).attr('data_tab');
jQuery(this).parents('.collection_tabs_section').find('.collection_tab_trigger').removeClass('active');
jQuery(this).addClass('active');
jQuery(this).parents('.collection_tabs_section').find('.collection_tabs_content').hide();
jQuery(this).parents('.collection_tabs_section').find('.collection_tabs_content[data_tab="'+current_tab+'"]').show();
jQuery(this).parents('.collection_tabs_section').find('.slider-counter--counter').hide();
jQuery(this).parents('.collection_tabs_section').find('.slider-counter--counter[data_tab="'+current_tab+'"]').show();
jQuery(this).parents('.collection_tabs_section').find('.collection_tabs_content[data_tab="'+current_tab+'"] .collection_tabs_products').slick('refresh');
});


jQuery('select.collection_tabs_triggers_select.mobile_only').change(function(){
var current_tab = jQuery(this).val();
jQuery(this).addClass('active');
jQuery(this).parents('.collection_tabs_section').find('.collection_tabs_content').hide();
jQuery(this).parents('.collection_tabs_section').find('.collection_tabs_content[data_tab="'+current_tab+'"]').show();
jQuery(this).parents('.collection_tabs_section').find('.slider-counter--counter').hide();
jQuery(this).parents('.collection_tabs_section').find('.slider-counter--counter[data_tab="'+current_tab+'"]').show();
jQuery(this).parents('.collection_tabs_section').find('.collection_tabs_content[data_tab="'+current_tab+'"] .collection_tabs_products').slick('refresh');
});


 let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });


jQuery("input.varaint_label_custom").focus(function(e) {
jQuery(this).parents('.product_variant_select').find('.product_variant_select_dropdown').slideDown();
});
jQuery("input.varaint_label_custom").focusout(function(e) {
jQuery(this).parents('.product_variant_select').find('.product_variant_select_dropdown').slideUp();
});

jQuery("input.varaint_label_custom").on("input", function() {
jQuery(this).parents('.product_variant_select').find('.product_variant_select_dropdown').slideDown();
var input_value = jQuery(this).val();
var this_element = jQuery(this);
jQuery(this).parents('.product_variant_select').find('.product_variant_select_dropdown_item').each(function(){
var variant_title = jQuery(this).text().toLowerCase(); 
var variant_id = jQuery(this).attr('variant_id');
if(variant_title.indexOf(input_value) != -1){
jQuery(this).show(); 
} else {
jQuery(this).hide();    
}
});
});
jQuery(".product_variant_select_dropdown_item").click(function(e) {
var variant_title = jQuery(this).text(); 
var variant_id = jQuery(this).attr('variant_id');
jQuery(this).parents('.product_variant_select').find('input.varaint_label_custom').val(variant_title);
jQuery(this).parents('.product_variant_select').next().attr('variant_id',variant_id);
});
jQuery(document).on('click','.appstle_widget_title',function(){
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
});

jQuery("input.search_collection_custom").on("input", function() {
    jQuery(this).toggleClass('active');
    //jQuery(this).next().slideToggle();
});
jQuery("summary#HeaderDrawer-shop-all,summary#HeaderDrawer-bundles-sets").click(function(e) {
jQuery(this).next().find('summary').trigger('click');
});


jQuery(document).on('click','.custom_price_label',function(){
var price = jQuery(this).find("input[name='price_custom']").val();
if (price != null && price != "") {
var price_array = price.split('-');
var price_min =  price_array[0];
var price_max =  price_array[1];
jQuery('input#Filter-Price-GTE').val(price_min);
jQuery('input#Filter-Price-LTE').val(price_max);
}
});
jQuery("input.search_collection_custom").on("input", function() {
var input_value = jQuery(this).val();
var this_element = jQuery(this); 
  setTimeout(function () {
this_element.parents('.shopify-section').find('ul#product-grid .collection_tab_product_title').each(function(){
var product_title = jQuery(this).text().toLowerCase(); 
if(product_title.indexOf(input_value) != -1){
jQuery(this).parents('li').show(); 
} else {
jQuery(this).parents('li').hide();    
}
});
}, 500);
});


jQuery(document).on('click','.custom_menu_label:not(.active)',function(){
var link = jQuery(this).attr('href');
if (link != null && link != "") {
location.href=link;
}
});
jQuery(document).on('click','.custom_menu_label.active',function(){
location.href="/collections/all";
});

jQuery(".sets_custom_item:not(.active) .sets_custom_item_inner").click(function(e) {
     e.preventDefault();
   document.querySelector('#set').scrollIntoView({ 
  behavior: 'smooth' 
})
});
jQuery("a[href='#build_set']").click(function(e) {
     e.preventDefault();
   document.querySelector('#build_set').scrollIntoView({ 
  behavior: 'smooth' 
})
});






jQuery(document).on("click", '.appstle_sub_widget input[name=selling_plan]', function(event) { 
 setTimeout(function () {
var selling_plan = jQuery('input[name="selling_plan"]:checked').val();
if (selling_plan != ""){
  jQuery('.product-form__submit.button.button--primary span:first-child').addClass('subscribe_hidden');
  jQuery('.subscribe_show').addClass('active');
  } else {
  jQuery('.subscribe_hidden').removeClass('subscribe_hidden');
  jQuery('.subscribe_show.active').removeClass('active');
   }
 }, 500);
});


jQuery('.question_product,.faq_question').click(function(){
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
});




jQuery(document).on('click','.custom_toggle_sub:not(.active)',function(){ 
jQuery(this).addClass('active');
var id = jQuery(this).attr('variant_id');
var line = jQuery(this).attr('line_item');
var quantity = jQuery(this).attr('quantity');
var selling_plan = jQuery(this).attr('selling_plan');
jQuery(this).parents('tr').find('.loading__spinner').removeClass('hidden');
jQuery.ajax({
type: 'POST',
url: '/cart/change.js',
data: {
  'line': line,
  'quantity': quantity,
  'id': id,
  'selling_plan': selling_plan
},
  dataType: 'json', 
    success: function() {
jQuery("cart-drawer").load(location.href + " #CartDrawer");
setTimeout(function() {
jQuery("cart-drawer").removeClass('is-empty').addClass('active');
jQuery("body ").addClass('overflow-hidden');
}, 1000);
    },
    error: function() {
    }
  });
})

jQuery(document).on('click','.custom_toggle_sub.active',function(){ 
jQuery(this).removeClass('active');
var id = jQuery(this).attr('variant_id');
var line = jQuery(this).attr('line_item');
var quantity = jQuery(this).attr('quantity');
var selling_plan = jQuery(this).attr('selling_plan');
jQuery(this).parents('tr').find('.loading__spinner').removeClass('hidden');
jQuery.ajax({
type: 'POST',
url: '/cart/change.js',
data: {
  'line': line,
  'quantity': quantity,
  'id': id,
  'selling_plan': null
},
  dataType: 'json', 
    success: function() {
jQuery("cart-drawer").load(location.href + " #CartDrawer");
setTimeout(function() {
jQuery("cart-drawer").removeClass('is-empty').addClass('active');
jQuery("body ").addClass('overflow-hidden');
}, 1000);

jQuery(this).parents('tr').find('.loading__spinner').addClass('hidden');
    },
    error: function() {
    }
  });
})

jQuery(document).on('click','.facets-vertical .active-facets-vertical-filter',function(){ 
jQuery(this).parents('facet-filters-form.facets.small-hide').addClass('active');
});

jQuery(document).on('click','.close_form_custom',function(){ 
jQuery(this).parents('facet-filters-form.facets.small-hide').removeClass('active');
});

jQuery(document).on('click','.facets__label',function(){
jQuery('.active_filters_count').hide();
setTimeout(function() {
  var active_filters = jQuery('body .facets-vertical .facet-checkbox input[type=checkbox]:checked').length;
jQuery('.active_filters_count').text('('+active_filters+')');
jQuery('.active_filters_count').show();
}, 3000);
setTimeout(function() {
  var active_filters = jQuery('body .facets-vertical .facet-checkbox input[type=checkbox]:checked').length;
jQuery('.active_filters_count').text('('+active_filters+')');
jQuery('.active_filters_count').show();
}, 6000);
setTimeout(function() {
  var active_filters = jQuery('body .facets-vertical .facet-checkbox input[type=checkbox]:checked').length;
jQuery('.active_filters_count').text('('+active_filters+')');
jQuery('.active_filters_count').show();
}, 9000);
});
jQuery("a[href='#faq']").click(function(e) {
     e.preventDefault();
   document.querySelector('#faq').scrollIntoView({ 
  behavior: 'smooth' 
})
});


jQuery(".subscription_options input").change(function(e) {
var sellling_plan = jQuery(this).parents('.custom_subscription_widget').find('input:checked').val();
jQuery(this).parents('.custom_popup_flex_content').find('.trigger_button').attr('selling_plan',sellling_plan);
});